export default {
  modals: [],
  status: [],
  stats: {},
  bank: [],
  notify: {
    read: [],
    readed: []
  },
};
